export default "__VITE_ASSET__RWxq0xQa__"